import React from 'react';
import { SUPPORT_EMAIL, INSTAGRAM } from '../lib/config';
export function Footer() {
  return <footer className="w-full border-t border-gold-soft bg-ivory py-14" data-id="element-110" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-111" data-mp="32nukolv2nz0b">
        <p className="font-serif text-2xl text-ink" data-id="element-112" data-mp="32pfeg99kbdx4">The Wedding Pro OS™</p>
        <div className="rule-gold mx-auto mt-6 w-24" aria-hidden="true" data-id="element-113" data-mp="36oo5359b2vog" />
        <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-ink-soft" data-id="element-114" data-mp="3ufa4k858v7mu">
          The complete operating system for wedding planners who refuse to wing
          someone&rsquo;s most important day.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-ink-soft" data-id="element-115" data-mp="3ldamdcihtxib">
          <li data-id="element-116" data-mp="3qc3zh3tvbmhy">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors hover:text-gold-dark" data-id="element-117" data-mp="3qblw7n8sg80j">
              {SUPPORT_EMAIL}
            </a>
          </li>
          <li data-id="element-118" data-mp="2ezl35w4w5xez">
            <a href="#" className="transition-colors hover:text-gold-dark" data-id="element-119" data-mp="2evx8gtnpn4yo">
              {INSTAGRAM}
            </a>
          </li>
          <li data-id="element-120" data-mp="3gaz3l7v1stm7">
            <a href="#" className="transition-colors hover:text-gold-dark" data-id="element-121" data-mp="3gbin2t0cjq2c">
              Terms &amp; Conditions
            </a>
          </li>
          <li data-id="element-122" data-mp="3v5n7ihksvjzp">
            <a href="#" className="transition-colors hover:text-gold-dark" data-id="element-123" data-mp="3q8mzw28ay96h">
              Privacy Policy
            </a>
          </li>
        </ul>

        <p className="mt-10 text-[11px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-124" data-mp="81pghm1kl3ay">
          © {new Date().getFullYear()} The Wedding Pro OS™. All rights reserved.
        </p>
      </div>
    </footer>;
}